import createAction from 'redux-actions/lib/createAction';
import { SET_SHOW_TOOLTIPS } from './actionTypes';

export const setShowTooltips = createAction(SET_SHOW_TOOLTIPS);
